import { MdArrowDropDown } from 'react-icons/md';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export type CustomTagMatch = 'all' | 'any';

const items: { value: CustomTagMatch; label: string }[] = [
  { value: 'all', label: '全てを含む（AND）' },
  { value: 'any', label: 'いずれかを含む（OR）' },
];

interface Props {
  value: CustomTagMatch | undefined;
  onChange: (value: CustomTagMatch) => void;
}

export default function CustomTagMatchMenu({ value, onChange }: Props) {
  const current = items.find((item) => item.value === value) ?? items[0];

  return (
    <div className="flex items-center border-0 border-b border-solid border-border bg-white px-sm">
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="group flex h-[42px] cursor-pointer items-center gap-xxs rounded-sm border-0 bg-transparent px-xs text-button-md whitespace-nowrap text-main"
          >
            {current.label}
            <MdArrowDropDown className="size-icon-xs transition-transform duration-200 group-data-[state=open]:rotate-180" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          sideOffset={4}
          className="z-[9999]! min-w-[163px]! rounded-sm! border-0! p-0! shadow-layer3!"
        >
          {items.map((item) => (
            <DropdownMenuItem
              key={item.value}
              onSelect={() => onChange(item.value)}
              className="cursor-pointer! rounded-none! px-sm! py-xs! text-body-sm! whitespace-nowrap text-main"
            >
              {item.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
